import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';

const COLOR_CLASSES = {
    default: 'bg-dark-blue/20',
    warning: 'bg-warning',
    success: 'bg-success',
    danger: 'bg-danger',
};

export default function ProgressBar(props) {
    const {
        value = 0,
        max = 100,
        label,
        bottomLeftText = '',
        bottomRightText = '',
        variant = 'normal',
        color = 'default',
        className,
    } = props;
    const percentage = max > 0 ? Math.min((value / max) * 100, 100) : 0;

    return (
        <div className={cn('w-full', className)}>
            {label && <div className="text-xs font-semibold text-dark-blue mb-1.5">{label}</div>}
            <div
                className={cn(
                    'w-full bg-gray-200 rounded-full h-1.5',
                    variant === 'gradient' && 'h-3 p-0.5 bg-white shadow',
                )}
            >
                <div
                    className={cn(
                        'h-full rounded-full transition-all duration-300 ease-in-out',
                        variant === 'gradient'
                            ? 'bg-gradient-to-r from-primary via-[#A64EFF] to-[#C920A0]'
                            : COLOR_CLASSES[color] ?? COLOR_CLASSES.default,
                    )}
                    style={{ clipPath: `inset(0 ${100 - percentage}% 0 0 round 99999px)` }}
                    role="progressbar"
                    aria-valuenow={value}
                    aria-valuemin="0"
                    aria-valuemax={max}
                />
            </div>
            {(bottomLeftText || bottomRightText) && (
                <div className="flex justify-between items-center py-1.5 text-2xs text-gray-500">
                    <span>{bottomLeftText}</span>
                    <span>{bottomRightText}</span>
                </div>
            )}
        </div>
    );
}

ProgressBar.propTypes = {
    value: PropTypes.number,
    max: PropTypes.number,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    bottomLeftText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    bottomRightText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    className: PropTypes.string,
    variant: PropTypes.oneOf(['normal', 'gradient']),
    color: PropTypes.oneOf(['default', 'warning', 'success', 'danger']),
};
